export const getSubdomain = () => {
    return window.location.hostname === 'localhost' ? process.env.REACT_APP_DOMAIN : window.location.hostname;
}

// Domínio principal do cliente da sessão ativa: o host do sistema sem o
// segmento "sistema." (ex.: sistema.bestgiftsgroup.com.br ->
// bestgiftsgroup.com.br; cliente.sistema.brinde.me -> cliente.brinde.me).
export const getMainDomain = () => {
    return (getSubdomain() ?? '').replace(/(^|\.)sistema\./i, '$1');
}